import _config from '@tcc/shared/src/helpers/config';

_config.merge({
  'tcc.listenerDisabled': false,
  'tcc.manualPagePerf': false,
  'tcc.loadTTI': true,
  'tcc.gaAccountDev': 'UA-37178807-1',
  'tcc.gaAccountTest': 'UA-37178807-15',
  'tcc.gaAccountProd': 'UA-52262008-12',
  'tcc.ga4AccountDev': 'G-QR3LRHZZ2J',
  'tcc.ga4AccountTest': 'G-XVYQ3S2DCT',
  'tcc.ga4AccountProd': 'G-R9B47BVCG7',
  'tcc.sGtmAccountDev': '7HYF9CG8M9',
  'tcc.sGtmAccountTest': 'VHMTV22GNH',
  'tcc.sGtmAccountProd': 'GDG5C4J6CP',
  'tcc.webGtmAccountDev': 'GTM-P3TH7XW',
  'tcc.webGtmAccountTest': 'GTM-N3KGRWR',
  'tcc.webGtmAccountProd': 'GTM-NRK9LFR',
  'tcc.webGtmEnabled': true,
  'tcc.eventBusEnabled': false,
  'tcc.buildEnv': 'prod',
  'tcc.buildName': '@tcc/123Reg',
  'tcc.buildVersion': '3.46.21',
  'tcc.buildDate': '2023-10-06T11:45:18.146Z',
  'tcc.eventBusApiKey': 'b18ef4f046435b64a469b32c3c1c20a3',
  'tcc.eventBusRigorApiKey': '8da2217409854bee82e12dc4ca0b39fb',
  'tcc.ttiUrl': 'https://img6.wsimg.com/wrhs/ce554d2333f3801abafb32da18213ff7/tti.min.js',
  'tcc.sGtmHost': '123-reg.co.uk',
  'tcc.eventDelayMs': 75,
  'tcc.consentDelayMs': 500,
  cookie: {
    sameSite: 'none'
  },
  site: {
    privateLabelId: '587240'
  }
});

export default _config;
